import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { FloaterTypeService } from 'services/floater-type-service';
import { AsyncErrorHandler } from 'lib/ui';

@autoinject
export class FloaterTypeList {
  protected tableData: Array<Models.FloaterType>;
  protected activeTableRow: number;

  private constructor(private eventAggregator: EventAggregator, private router: Router, private floaterTypeService: FloaterTypeService) {}

  protected activate(params: { Id?: number }) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  protected attached() {
    this.eventAggregator.subscribe('floaterTypeListReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  @AsyncErrorHandler
  private async updateView() {
    this.tableData = await this.floaterTypeService.getAll();
  }

  protected gotoDetailView(id: number) {
    this.activeTableRow = id;
    this.router.navigateToRoute('floater-type-detail', { Id: id });
  }
}
